import React from "react";
import RepliesStates from "../types/replies_states";

const ShowRepliesButton = ({ repliesState, repliesCount, handleRepliesState, subthread }) => {
  const toggleReplies = () => {
    let nextRepliesState = RepliesStates.HIDDEN;

    if (repliesState === RepliesStates.HIDDEN && !subthread) {
      nextRepliesState = RepliesStates.SHOW_INCREMENT_AMOUNT;
    } else if (repliesState === RepliesStates.HIDDEN && subthread) {
      nextRepliesState = RepliesStates.FIRST_THREE;
    }

    handleRepliesState(nextRepliesState);
  }

  const repliesClass = !(repliesState === RepliesStates.HIDDEN) && repliesCount > 0 ? 'highlighted' : '';
  let repliesText = `${repliesCount || '' }${repliesCount > 1 ? ' Replies' : ' Reply'}`;

  return (
    <a className={ repliesClass } onClick={ () => toggleReplies() }>{ repliesCount == 0 && subthread ? null : repliesText }</a>
  );

}

export default ShowRepliesButton;
